var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloatingTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.606445 1.69421C0.606445 1.14193 1.05416 0.694214 1.60645 0.694214H17.6063C18.1586 0.694214 18.6063 1.14193 18.6063 1.69421C18.6063 2.2465 18.1586 2.69421 17.6063 2.69421H1.60645C1.05416 2.69421 0.606445 2.2465 0.606445 1.69421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2648 6.55321C9.88773 6.22331 9.32477 6.22331 8.94774 6.55321L0.947804 13.5532C0.53217 13.9169 0.490054 14.5487 0.853738 14.9643C1.21742 15.3799 1.84918 15.422 2.26482 15.0584L9.60625 8.63456L16.9477 15.0584C17.3633 15.422 17.9951 15.3799 18.3588 14.9643C18.7224 14.5487 18.6803 13.9169 18.2647 13.5532L10.2648 6.55321Z",
    fill: "#F3EFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingTop);
export default __webpack_public_path__ + "static/media/floating_top.ea7381acaaed653d39be6e40da53c054.svg";
export { ForwardRef as ReactComponent };